module.exports = __webpack_public_path__ + "media/images/icons/SVG/021-7789cbb058aba817f312980782d3bcc6.svg";